import axios from 'axios';

import getUserEmail from '../../../selectors/getUserEmail';
import * as SubscriptionSelectors from '../selectors/subscription';
import authIdInputValue$ from '../../../selectors/getUserId';

import * as SubFormOptionsActions from '../actions/subFormOptions';
import * as SubFormSendActions from '../actions/subFormSend';
import * as ExistSubscriptionActions from '../actions/existSubscription';
import subToasterContentAndTypeCreator from './subToaster/subToasterContentAndType';
import reloadExistSubscription from './reloadExistSubscription';
import { gaSendEvent } from './gaSendEvent';

import * as Api from '../utils/api';
import fetchFormDataHandler from '../utils/fetchFormDataHandler.js';
import pickFormParameters from '../utils/pickFormParameters';
import { URL_GET_EXIST_REPORT_BY_ID } from '../utils/urlUtils/subscription';
import * as Const from '../constants';

import ReduxAction from '../../../interfaces/ReduxAction';

export const fetchSubscriptionDataForm = (): ReduxAction => {
  return (dispatch): void => {
    dispatch(SubFormOptionsActions.subFormIsLoading(true));

    Api.subscriptionGet()
      .then(response => {
        dispatch(
          SubFormOptionsActions.subChangeAvailablePackage(fetchFormDataHandler(response.data).package_)
        );
        dispatch(
          SubFormOptionsActions.subChangeAvailableProduct(fetchFormDataHandler(response.data).product)
        );
        dispatch(
          SubFormOptionsActions.subFormIsLoading(false)
        );
      })
      .catch(() => {
        dispatch(SubFormOptionsActions.subFormIsLoading(false));
        dispatch(SubFormOptionsActions.subFormError(true));
      });
  };
};

export const fetchExistUserSubscription = (): ReduxAction => {
  return (dispatch, getState): void => {
    dispatch(ExistSubscriptionActions.existSubIsLoading());
    axios.get(URL_GET_EXIST_REPORT_BY_ID(authIdInputValue$(getState())))
      .then(response => {
        dispatch(ExistSubscriptionActions.existSubSubscription(response.data));
        if (response.data.data === null) {
          dispatch(subToasterContentAndTypeCreator(
            Const.SUBSCRIPTION_MESSAGE.loadExist.warning,
            Const.MESSAGE_TYPE.warning
          ));
          dispatch(ExistSubscriptionActions.existSubNotLoading());
        }
      })
      .catch(reason => {
        dispatch(ExistSubscriptionActions.existSubSubscription(null));

        let subErrorContent = 'Failed to load Exist Subscription list';
        if (reason.response && reason.response.data && reason.response.data.detail && reason.response.data.detail) {
          subErrorContent += `. ${reason.response.data.detail}`;
        }
        dispatch(subToasterContentAndTypeCreator(
          subErrorContent,
          Const.MESSAGE_TYPE.fail
        ));
        dispatch(ExistSubscriptionActions.existSubNotLoading());
      });
  };
};

export const sendSubscriptionForm = (): ReduxAction => {
  return (dispatch, getState): void => {
    dispatch(SubFormSendActions.subFinishedForm(pickFormParameters(
      getUserEmail(getState()),
      SubscriptionSelectors.dateFrom$(getState()),
      SubscriptionSelectors.dateTo$(getState()),
      SubscriptionSelectors.fieldsArea$(getState()),
      SubscriptionSelectors.planePrice$(getState()),
      SubscriptionSelectors.typePayment$(getState()),
      SubscriptionSelectors.package$(getState()),
      SubscriptionSelectors.product$(getState()),
      SubscriptionSelectors.subscriptionPeriod$(getState()),
      SubscriptionSelectors.shouldCreatePayment$(getState())
    )));

    const planePrice = SubscriptionSelectors.planePrice$(getState());
    const userId = authIdInputValue$(getState());

    dispatch(SubFormSendActions.subFormIsSending());
    dispatch(ExistSubscriptionActions.existSubIsLoading());

    Api.sendSubscriptionForm(SubscriptionSelectors.finishedForm$(getState()))
      .then(() => {

        if (SubscriptionSelectors.typePayment$(getState()) === Const.INVOICE) {
          gaSendEvent(planePrice, userId);
        }

        dispatch(subToasterContentAndTypeCreator(
          Const.SUBSCRIPTION_MESSAGE.add.success,
          Const.MESSAGE_TYPE.success
        ));
        dispatch(SubFormSendActions.subFormSentSuccess());

        dispatch(reloadExistSubscription());

        dispatch(SubFormSendActions.subFinishedForm({}));

      }).catch(reason => {

        dispatch(SubFormSendActions.subFormNotSend());
        dispatch(ExistSubscriptionActions.existSubNotLoading());
        dispatch(subToasterContentAndTypeCreator(
          `${Const.SUBSCRIPTION_MESSAGE.add.fail}. ${reason}`,
          Const.MESSAGE_TYPE.fail
        ));
        dispatch(SubFormSendActions.subFinishedForm({}));
      });
  };
};
